var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFavouritedMutualAvatarDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "58px",
    viewBox: "0 0 58 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFavouritedMutualAvatarDesktop Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M25,0 C11.2502274,0 0,11.2502274 0,25 C0,38.7497726 11.2502274,50 25,50 C38.7497726,50 50,38.7497726 50,25 C50,11.2502274 38.7497726,0 25,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.0%",
    y: "-11.0%",
    width: "126.0%",
    height: "126.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.438309,15.7374134 C21.8471139,15.3390053 21.9914225,14.7542853 21.8150915,14.210737 C21.6383448,13.6671886 21.1779713,13.2791774 20.6123816,13.1968342 L15.5836235,12.4661422 C15.369448,12.4349515 15.1843837,12.300624 15.0887325,12.1064105 L12.8405133,7.55008611 C12.5880773,7.03814422 12.0757195,6.72 11.5047234,6.72 C10.9341432,6.72 10.4217854,7.03814422 10.1693494,7.55008611 L7.92071436,12.1068263 C7.82506315,12.3010399 7.63958299,12.4353674 7.42540747,12.466558 L2.39664934,13.1972501 C1.83147549,13.2791774 1.3706862,13.6676045 1.19393941,14.2111528 C1.0176085,14.7547012 1.16191705,15.3394212 1.57072198,15.7378292 L5.20921064,19.2844096 C5.36433194,19.435788 5.43544653,19.6537064 5.39884955,19.8666343 L4.54048396,24.8745987 C4.46437887,25.315426 4.57999206,25.7441929 4.86528218,26.0822991 C5.30860472,26.6092125 6.08254773,26.7697402 6.70136944,26.4445261 L11.1986396,24.0798619 C11.386615,23.9812996 11.6232477,23.9821313 11.8108073,24.0798619 L16.3084933,26.4445261 C16.5272434,26.5597234 16.7605492,26.6179458 17.0013407,26.6179458 C17.4409204,26.6179458 17.8576269,26.4224847 18.1441647,26.0822991 C18.4298706,25.7441929 18.545068,25.3145942 18.4689629,24.8745987 L17.6101814,19.8666343 C17.5735844,19.6532905 17.644699,19.435788 17.7998203,19.2844096 L21.438309,15.7374134 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5447802,5.94186849 C26.7633798,5.72882832 26.8405458,5.41616185 26.7462566,5.12551101 C26.651745,4.83486018 26.4055702,4.62737951 26.1031332,4.58334824 L23.4141126,4.19262634 C23.2995868,4.17594783 23.2006277,4.10411905 23.1494802,4.00026752 L21.9472932,1.56387075 C21.8123085,1.2901208 21.5383362,1.12 21.2330082,1.12 C20.9279027,1.12 20.6539304,1.2901208 20.5189456,1.56387075 L19.3165362,4.00048991 C19.2653888,4.10434143 19.1662072,4.17617021 19.0516815,4.19284872 L16.3626609,4.58357062 C16.0604463,4.62737951 15.8140491,4.83508256 15.7195375,5.12573339 C15.6252483,5.41638423 15.7024142,5.7290507 15.9210139,5.94209087 L17.8666177,7.83854868 C17.9495655,7.91949505 17.9875925,8.03602224 17.9680231,8.14988087 L17.5090305,10.8277825 C17.4683349,11.0635054 17.5301566,11.2927793 17.6827094,11.4735744 C17.9197666,11.75533 18.333616,11.8411687 18.6645177,11.6672675 L21.0693365,10.402814 C21.1698523,10.3501099 21.2963866,10.3505547 21.39668,10.402814 L23.8017212,11.6672675 C23.9186931,11.7288668 24.0434484,11.76 24.1722065,11.76 C24.4072623,11.76 24.6300872,11.6554813 24.7833071,11.4735744 C24.9360823,11.2927793 24.9976816,11.0630607 24.956986,10.8277825 L24.497771,8.14988087 C24.4782016,8.03579986 24.5162286,7.91949505 24.5991764,7.83854868 L26.5447802,5.94186849 Z",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icFavouritedMutualAvatarDesktop-Copy",
    transform: "translate(4.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke-1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons/Star-Favorite-match",
    transform: "translate(11.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#10C2E1",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask-Copy",
    fill: "#10C2E1",
    fillRule: "nonzero",
    xlinkHref: "#path-5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFavouritedMutualAvatarDesktop);
export default __webpack_public_path__ + "static/media/icFavouritedMutualAvatarDesktop.11bbcd9097890ef1319a7db85c3f860d.svg";
export { ForwardRef as ReactComponent };